/*
 *  I11PERCHADISCHACalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-18 12:59:00 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchTube, fetchMasseVolumiqueViscosite, fetchPerteChargeUnite } from '@batical/data/src'
import { RTubes_Type, RMasseVolumiqueViscosite_Type, RPerteChargeUniteCalculSchema_Type, I11PERCHADISCHA_State } from '@batical/types/src'

import { nombreReynolds, calculVitesseTuyaux, colebrook } from '../CommonFormula'

function I11PERCHADISCHA_docalcul(state: I11PERCHADISCHA_State) {
  state.invalidated = false
  let tube: RTubes_Type = fetchTube(state.tube_uuid)
  let selectedviscosite: RMasseVolumiqueViscosite_Type = fetchMasseVolumiqueViscosite(state.viscosite_uuid)
  let selectedperteCharg: RPerteChargeUniteCalculSchema_Type = fetchPerteChargeUnite(state.perteCharg_uuid)
  //TODO CALCUL
  state.res_vitesse = calculVitesseTuyaux(state.in_debit, tube.diamInt)
  const res_nbrReynolds = nombreReynolds(state.in_debit, tube.diamInt, selectedviscosite.viscositeKgms * selectedviscosite.masseVolumique)
  let res_facPerteCharge = 0
  if (res_nbrReynolds < 3000) {
    res_facPerteCharge = 64 / res_nbrReynolds
  } else if (res_nbrReynolds < 10e11) {
    res_facPerteCharge = colebrook(res_nbrReynolds, tube.rugositeMax, tube.diamInt)
  } else {
    res_facPerteCharge = 0
    state.res_pdcParMetre = -1
    state.res_pdcTotale = -1
  }
  if (res_nbrReynolds < 10e11) {
    state.res_pdcParMetre =
      ((((res_facPerteCharge * 1000) / tube.diamInt) * selectedviscosite.masseVolumique * Math.pow(state.res_vitesse, 2)) / 2) *
      selectedperteCharg.factor

    state.res_pdcTotale = state.res_pdcParMetre * state.in_longueur
  }
  // console.log('I11PERCHADISCHA_docalcul', res_facPerteCharge, state)
  return state
}

export default I11PERCHADISCHA_docalcul
